import React from "react";
import { motion } from "framer-motion";

import react from "../../assects/icons/skills/react.svg";
import redux from "../../assects/icons/skills/redux.svg";
import next from "../../assects/icons/skills/next.svg";
import js from "../../assects/icons/skills/js.svg";
import ts from "../../assects/icons/skills/ts.svg";
import html from "../../assects/icons/skills/html.svg";
import api from "../../assects/icons/skills/api.svg";
import node from "../../assects/icons/skills/node.png";
import mongodb from "../../assects/icons/skills/mongodb.png";
import firebase from "../../assects/icons/skills/firebase.svg";
import figma from "../../assects/icons/skills/figma.svg";
import css from "../../assects/icons/skills/css.svg";
import scss from "../../assects/icons/skills/scss.svg";
import mui from "../../assects/icons/skills/mui.svg";
import styled from "../../assects/icons/skills/styled.png";
import tailwind from "../../assects/icons/skills/tailwind.svg";
import wordpress from "../../assects/icons/skills/wordpress.svg";
import git from "../../assects/icons/skills/git.svg";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import Tooltip from "../Tooltip/Tooltio";

const Skills = () => {
  const skillsImages = [
    {
      react: "3",
      percentage: "80",
      name: "React",
      image: react,
    },
    {
      redux: "3",
      percentage: "50",
      name: "redux",
      image: redux,
    },
    {
      nextjs: "3",
      percentage: "70",
      name: "nextJS",
      image: next,
    },
    {
      js: "3",
      percentage: "60",
      name: "Javascript",
      image: js,
    },
    {
      ts: "3",
      percentage: "60",
      name: "TypeScript",
      image: ts,
    },
    {
      html: "3",
      percentage: "90",
      name: "HTML",
      image: html,
    },
    {
      api: "3",
      percentage: "65",
      name: "API",
      image: api,
    },
    {
      mongodb: "3",
      percentage: "40",
      name: "Mongo db",
      image: mongodb,
    },
    {
      mongodb: "3",
      percentage: "30",
      name: "Node JS",
      image: node,
    },
    {
      firebase: "3",
      percentage: "55",
      name: "Firebase",
      image: firebase,
    },
    {
      figma: "3",
      percentage: "80",
      name: "Figma",
      image: figma,
    },
    {
      css: "3",
      percentage: "85",
      name: "CSS 3",
      image: css,
    },
    {
      tailwind: "3",
      percentage: "90",
      name: "Tailwind css",
      image: tailwind,
    },
    {
      scss: "3",
      percentage: "45",
      name: "SCSS",
      image: scss,
    },
    {
      styled: "3",
      percentage: "60",
      name: "Styled Component",
      image: styled,
    },
    {
      mui: "3",
      percentage: "65",
      name: "Material UI",
      image: mui,
    },

    {
      wordpress: "3",
      percentage: "80",
      name: "WordPress",
      image: wordpress,
    },
    {
      git: "3",
      percentage: "75",
      name: "Git",
      image: git,
    },
  ];

  const skillsVariants = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
        delayChildren: 0.4,
        staggerChildren: 0.2,
        damping: 30,
      },
    },
  };

  const skillItem = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        damping: 100,
      },
    },
  };

  return (
    <>
      <motion.div variants={skillsVariants} initial="hidden" animate="visible">
        <h3 className="text-[33px]  font-bold font-robotoSlab pb-7">
          Skills 🔥
        </h3>
        <div className="flex flex-wrap gap-10 pb-6">
          {skillsImages.map((skill) => {
            return (
              <Tooltip content={skill.name} direction="top">
                <motion.div
                  variants={skillItem}
                  initial="hidden"
                  animate="visible"
                  className="w-20"
                >
                  <CircularProgressbarWithChildren
                    value={skill.percentage}
                    strokeWidth={4}
                    styles={{
                      path: {
                        // Path color
                        // stroke: `rgba(62, 152, 199, ${30 / 100})`,
                        strokeLinecap: "round",
                      },
                      // Customize the circle behind the path, i.e. the "total progress"
                      trail: {
                        // Trail color
                        stroke: "#d6d6d6",
                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                        strokeLinecap: "round",
                      },
                    }}
                  >
                    <img style={{ width: "58%" }} src={skill.image} alt="#" />
                  </CircularProgressbarWithChildren>
                </motion.div>
              </Tooltip>
            );
          })}
        </div>
      </motion.div>
    </>
  );
};

export default Skills;
